const time = () => {
    let time = new Date().getHours(), timeq = '';        
    if (time >= 18 || time < 7) timeq = 'Evening';
    if (time >= 7 && time < 12) timeq = 'Morning';
    if (time >= 12 && time < 18) timeq = 'Afternoon';
    return timeq
};

export default time;